export interface EncodedPDFFile {
  encoded_string: string;
}

export enum PDFAcceptingNewPatientsType {
  Yes = 'Yes',
  No = 'No',
}

export interface PDFProviderDetails {
  providerName: string;
  specialties: string[];
  officeName?: string;
  address?: string;
  acceptingNewPatients?: PDFAcceptingNewPatientsType;
  distance?: string;
  phoneNumber: string;
  faxNumber?: string;
  npi: string;
  score?: string;
  rating?: string;
  openingHours?: string[];
  networkStatus?: string;
}

interface PDFPatientDetails {
  name: string;
  dateOfBirth: string;
  age: number;
}

export interface OrderAssistResultsPDFInput {
  patient?: PDFPatientDetails;
  clinicName: string;
  exportingUser: string;
  dateOfExporting: string;
  datasourceLogo?: string;
  results?: PDFProviderDetails[];
  featuredResults?: PDFProviderDetails[];
  alternativeResults?: PDFProviderDetails[];
  useGenericSearchTitles?: boolean;
}
